import './listVotes.css'


const ListVotes = ({ votes }) => {

    return (
        <div className='container-list'>
            {votes && votes.length > 0
                ? votes.map((vot, index) =>
                    <div  key={index} className='list-items'>
                        <p>{vot.CAN_TITULO} </p>
                        <p>{vot.VOT_COUNT}</p>
                    </div>
                )
                : <div className='list-empty'>
                    <h5>Todavía no hay votos</h5>
                </div>
            }
        </div>
    )
}
export default ListVotes